import gql from "graphql-tag";


export const List = gql`
query Workshops($filter: TableWorkshopFilterInput, $limit: Int, $nextToken: String) {
  listWorkshops(filter: $filter, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      workshopId
      userId
      user {
        userId
        given_name
        family_name
        email
      }
      event {
        title
      }
      competition {
        code
        date
        i18n_title
      }
      userData
    }
  } 
}
`;

export const Get = gql`
query GetWorkshop($workshopId: ID!, $userId: ID!) {
  getWorkshop(workshopId: $workshopId, userId: $userId) {
    workshopId
    userId
    event {
      id
      title
    }
    competition {
      id: competitionId
      title: i18n_title
    }
    hasAcceptedCompetitionRules
    userData
    previousExperience
    informationSource
  }
}
`;

// TODO make th
export const ListEvents = gql`
  query ListEvents (
    $filter: TableEventFilterInput, 
    $limit: Int,
    $nextToken: String
  )
  {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        value: id 
        text: title
        location
        type
        competitions {
          id: competitionId
          code
          date
          beginTime
          endTime
          organizer
    	  competitionRulesURL 
          teamMemberLimit
          participantLimit
          participantCount
      	  robotRequired
      	  published
          difficulty
          i18n_title
          i18n_description
        }
      }
    }
}
`;

export const Update = gql`
  mutation UpdateWorkshop($input: UpdateWorkshopInput!) {
    updateWorkshop(input: $input) {
      workshopId
      competitionId
      eventId
      hasAcceptedCompetitionRules
      userData
      previousExperience
      informationSource
    }
  }
`;


export const ListCompetitionUsers = gql`
query ListCompetitionUsers($competitionId: ID!) {
  listCompetitionUsers(competitionId: $competitionId) {
    name
    robotName
    userId
    country_of_residence
    occupation
    occupation_details
    given_name
    family_name
    email
  } 
}
`;

export const Delete = gql`
  mutation DeleteWorkshop($input: DeleteWorkshopInput!) {
    deleteWorkshop(input: $input) {
      workshopId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/Workshops/graphql.js